import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ExpenseCustomerState} from "@/interfaces/state";
import store from "@/store";
import {IdMapper} from "@/interfaces/state/base";
import {ExpenseCustomer} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {ExpenseCustomerParams} from "@/modules/receiptsexpenses/expensecustomer/params";
import { union, difference } from 'lodash';
import {listCreditCustomer, expenseCustomer} from "@/modules/receiptsexpenses/expensecustomer/services";
import {ExpensePickingListStore} from "@/modules/receiptsexpenses/expensepickinglist/store";

@Module({ dynamic: true, name: "expenseCustomerStore", store })
class ExpenseCustomerModule extends VuexModule implements ExpenseCustomerState {
    data: IdMapper<ExpenseCustomer> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ExpenseCustomerParams = new ExpenseCustomerParams();

    @Mutation
    private MAP_EXPENSE_CUSTOMER(payload: any) {
        const idMapper: IdMapper<ExpenseCustomer> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((expense: ExpenseCustomer, index: number) => {
            idMapper[expense.id] = {...expense, stt: index + 1};
            return expense.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_EXPENSE_CUSTOMER(payload: any) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = payload;
    }

    @Mutation
    private UPDATE_PARAMS_EXPENSE_CUSTOMER(payload: any) {
        this.params = payload;
    }

    @Mutation
    private DELETE_EXPENSE_CUSTOMER_BY_IDS(payload: number[]) {
        this.ids = this.ids.filter((id: number) => !payload.includes(id));
        payload.forEach((id: number) => delete this.data[id]);
    }

    @Mutation
    private CLEAR_EXPENSE_CUSTOMER_STORE() {
        this.ids = [];
        this.data = {};
    }

    @Action({ rawError: true })
    public async listCreditCustomer(params: any) {
        const { data } = await listCreditCustomer(params);
        this.MAP_EXPENSE_CUSTOMER(data);
        return data.datas;
    }

    @Action({ rawError: true })
    public updateParamsExpenseCustomer(payload: any) {
        this.UPDATE_PARAMS_EXPENSE_CUSTOMER(payload);
    }

    @Action({ rawError: true })
    public async expenseCustomer(dataReq: any) {
        const { data } = await expenseCustomer(dataReq);
        ExpensePickingListStore.setExpensePickingList(data.data);
        return data.data;
    }

    @Action({ rawError: true })
    public clearExpenseCustomerStore() {
        this.CLEAR_EXPENSE_CUSTOMER_STORE();
    }

    @Action({ rawError: true })
    public deleteDebtEmployeeByIds(payload: any) {
        this.DELETE_EXPENSE_CUSTOMER_BY_IDS(payload);
    }
}

export const ExpenseCustomerStore = getModule(ExpenseCustomerModule);